import downloadService from "./DownloadService";

export const DownloadService = {
  downloadEligibilityDocument: downloadService.downloadEligibilityDocument
};
